<template>
  <el-row class="create-user" v-loading="loading">
    <el-alert
      v-if="unhandledErrorMessage"
      :title="unhandledErrorMessage"
      type="error"
    ></el-alert>
    <el-form
      ref="userCreate"
      :model="user"
      size="mini"
      label-position="left"
      label-width="10em"
      :hide-required-asterisk="true"
    >
      <el-row class="details-section role">
        <el-form-item
          :label="userFormLabels[0].label"
          :error="castErrorKeyToLang(errMessagesObject.user_type)"
        >
          <el-select
            v-model="user.user_type"
            :placeholder="userFormLabels[0].placeholder"
          >
            <el-option
              v-for="(value, key) in userRolesInPondlogs"
              :key="key"
              :label="$tc(value.type_name, 1)"
              :value="value.value"
            ></el-option>
          </el-select>
          <div class="role-info">
            <img
              class="img-icon"
              src="@/assets/settings/exclamation-dark.svg"
            />
            <p>{{ $t(this.differentitateNames) }}</p>
          </div>
        </el-form-item>
      </el-row>
      <el-row class="details-section">
        <div class="header">
          <img class="img-icon" src="@/assets/settings/exclamation.svg" />
          <h4>User Information</h4>
        </div>
        <!-- <div class="user-name-element"> -->
        <el-form-item
          prop="first_name"
          :label="userFormLabels[1].label"
          :error="castErrorKeyToLang(errMessagesObject.first_name)"
        >
          <er-input
            v-model="user.first_name"
            class="input-box"
            :placeholder="userFormLabels[1].placeholder"
          ></er-input>
        </el-form-item>
        <el-form-item
          prop="last_name"
          class="name-element"
          :label="userFormLabels[2].label"
          :error="castErrorKeyToLang(errMessagesObject.last_name)"
        >
          <er-input
            v-model="user.last_name"
            class="input-box"
            :placeholder="userFormLabels[2].placeholder"
          ></er-input>
        </el-form-item>
        <el-form-item
          prop="email"
          :label="userFormLabels[3].label"
          :error="castErrorKeyToLang(errMessagesObject.email)"
        >
          <er-input
            v-model="user.email"
            class="input-box"
            :placeholder="userFormLabels[3].placeholder"
          ></er-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          :label="userFormLabels[4].label"
          :error="castErrorKeyToLang(errMessagesObject.phone)"
        >
          <er-input
            class="country-select input-box"
            v-model="user.phone"
            :placeholder="userFormLabels[4].placeholder"
            autocomplete="off"
          ></er-input>
        </el-form-item>
      </el-row>
      <el-row class="details-section">
        <div class="header" v-if="enablePermissions">
          <img class="img-icon" src="@/assets/settings/shield.svg" />
          <h4>Permissions</h4>
        </div>
        <pageAccessComponent
          :enableLocations="enableLocations"
          :enablePermissions="enablePermissions"
          :allotedLocations="user.allowed_locations"
          :givenPermissions="user.permissions"
          :errorMsgLocations="errMessagesObject.allowed_locations"
          :errorMsgPermissions="errMessagesObject.permissions"
          :type="'edit'"
          @selectedLocations="locations => (user.allowed_locations = locations)"
          @selectedPermissions="permissions => (user.permissions = permissions)"
        ></pageAccessComponent>
      </el-row>

      <el-row type="flex" justify="end" class="btn-action-container">
        <el-col
          :span="8"
          style="display: flex; justify-content: center; align-items:center"
        >
          <er-action-button
            :type="'save'"
            :disabled="isReadOnly"
            :bgColor="'#33A02C'"
            @action-btn-click="submitForm"
          >
            <template v-slot:icon>
              <img src="@/assets/ticks.svg" />
            </template>
            <template v-slot:label>
              <p style="color: white; margin-right: 4px;">
                {{ $t("Comn_save") }}
              </p>
            </template>
          </er-action-button>

          <div style="margin-left: 8px;">
            <er-action-button
              :type="'cancel'"
              :disabled="isReadOnly"
              @action-btn-click="resetForm"
            >
              <template v-slot:label>
                <p style="color: black">{{ `${$t("Comn_cancel")}` }}</p>
              </template>
            </er-action-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </el-row>
</template>

<script>
import User from "@/model/user.js";
import erInput from "@/components/base/erInput.vue";
import erButton from "@/components/base/erButton.vue";
import pageAccessComponent from "@/components/settings/pageAccessComponent";

import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";

import errorKeyMapMixin from "@/mixins/errorKeyMapMixin";

export default {
  mixins: [errorHandlerMixin, errorKeyMapMixin],
  props: ["user_details"],
  components: {
    erInput,
    erButton,
    pageAccessComponent
  },
  data: function() {
    return {
      user: new User(),
      errMessagesObject: new User(),
      userFormLabels: [],
      loading: false
    };
  },
  computed: {
    getAdminProfile: function() {
      return this.$store.getters["user/getUserProfile"];
    },
    isReadOnly() {
      return this.$store.getters["user/isReadOnly"];
    },
    enablePermissions: function() {
      return (
        ["POND_WORKER", "POND_TECHNICIAN", ""].indexOf(this.user.user_type) > -1
      );
    },
    enableLocations: function() {
      return (
        ["POND_WORKER", "POND_TECHNICIAN", "POND_MANAGER", ""].indexOf(
          this.user.user_type
        ) > -1
      );
    },
    differentitateNames() {
      console.log(this.user.user_type);
      return [
        { l: "POND_WORKER", info: "pond_worker_Info" },
        { l: "POND_TECHNICIAN", info: "pond_technician_Info" },
        { l: "POND_MANAGER", info: "pond_manager_Info" },
        { l: "POND_OWNER", info: "pond_owner_Info" },
        { l: "NO_ACCESS", info: "Usrs_no_access" }
      ].reduce((acc, curr) => {
        if (curr.l == this.user.user_type) {
          acc = curr.info;
        }
        return acc;
      }, "Comn_Info");
    }
  },
  created: function() {
    this.user = this.$lodash.cloneDeep(this.user_details);
    this.userFormLabels = [
      {
        label: this.$t("Usrs_role_select"),
        placeholder: this.$t("Usrs_select_atleast_one_role")
      },
      {
        label: this.$t("Usrs_first_name"),
        placeholder: this.$t("Usrs_enter_first_name")
      },
      {
        label: this.$t("Usrs_last_name"),
        placeholder: this.$t("Usrs_enter_last_name")
      },
      {
        label: this.$t("Comn_email_address"),
        placeholder: this.$t("Usrs_enter_email_addr")
      },
      {
        label: this.$t("Comn_mobile_num"),
        placeholder: this.$t("Usrs_enter_mobile_num")
      },
      {
        label: this.$t("Usrs_pwd"),
        placeholder: this.$t("Usrs_enter_pwd")
      },
      {
        label: this.$t("Comn_confirm_pwd"),
        placeholder: this.$t("Usrs_enter_confirm_pwd")
      }
    ];
  },
  mounted() {
    console.log("mounted");
    this.user = this.$lodash.cloneDeep(this.user_details);
  },
  methods: {
    resetForm() {
      this.user = this.$lodash.cloneDeep(this.user_details);
      this.errMessagesObject = new User();
      this.$emit("close");
    },
    intializations(user) {
      let isInitSuccess = true;
      this.loading = true;
      // this.user.phone = this.countryCode + this.user.phone;
      if (this.user.user_type === "NO_ACCESS") {
        // this.user.permissions = [];
        // this.user.allowed_locations = [];
      }
      if (
        this.user.user_type === "POND_MANAGER" ||
        this.user.user_type === "POND_OWNER" ||
        this.user.user_type === "NO_ACCESS"
      ) {
        delete this.user.permissions;
      }

      if (this.user.user_type === "POND_OWNER") {
        delete this.user.allowed_locations;
      }

      if (
        this.user.user_type != "NO_ACCESS" &&
        this.user.user_type != "POND_OWNER" &&
        !this.user.allowed_locations.length > 0
      ) {
        isInitSuccess = false;
        const err = {
          type: "FAIL_TO_SAVE",
          errors: [
            {
              message: this.$t("Usrs_atlst_one_loc_msg")
            }
          ]
        };
        this.errorMessages(err, true);
      }
      console.log(this.user.user_type, this.user);

      if (
        this.user.user_type != "POND_OWNER" &&
        this.user.user_type != "POND_MANAGER" &&
        this.user.user_type != "NO_ACCESS" &&
        !this.user.permissions.length > 0
      ) {
        isInitSuccess = false;
        const err = {
          type: "FAIL_TO_SAVE",
          errors: [
            {
              message: this.$t("Usrs_atlst_one_permi_msg")
            }
          ]
        };
        this.errorMessages(err, true);
      }
      this.errMessagesObject = new User();

      if (!isInitSuccess) {
        this.loading = false;
      }

      return isInitSuccess;
    },
    submitForm() {
      this.intializations() &&
        this.$store
          .dispatch("user/updateSubUser", {
            userId: this.user._id,
            payload: this.user
          })
          .then(response => {
            // console.log(response)
            this.$notify({
              title: this.$t("Usrs_success_msg"),
              message: this.$t("Usrs_usr_details_upd_successfully"),
              duration: 5000,
              type: "success"
            });
            this.$emit("close", "success");
          })
          .catch(err => {
            this.errorMessages(err, true);
          })
          .finally(() => {
            this.loading = false;
            this.$emit("reload");
          });
    }
  }
};
</script>

<style lang="scss">
.create-user {
  .el-select {
    width: 100%;
    .el-input__inner {
      width: 100%;
    }
  }
  .er-button {
    width: 14rem;
  }
  .details-section {
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;
    .text-container {
      @include responsiveProperty(
        font-size,
        $app_font_size_small,
        $app_font_size_1,
        $app_font_size_2
      );
    }
    .role-info {
      display: flex;
      align-items: center;
      margin-top: 4px;

      img {
        margin-right: 6px;
      }
      p {
        font-size: 11px;
      }
    }
  }

  .role {
    .el-form-item__label {
      color: #1f2041;
    }
  }

  .details-section:nth-of-type(1n) {
    padding-top: 0px;
  }
  // .details-section:nth-of-type(3n) {
  //   padding-bottom: 20px;
  // }
  .header {
    align-items: center;
    display: flex;
    padding-bottom: 20px;
    img {
      margin-right: 11px;
    }
  }

  .btn-action-container {
    display: flex;
    padding: 10px;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid rgb(221, 221, 221);
    border-right: 1px solid rgb(221, 221, 221);
  }

  .el-input--mini {
    font-size: 11px !important;
    width: 279px !important;
  }
}
</style>
